import { useQuery } from '@tanstack/react-query';

import { Reembolso } from '../types';

import { useListagemContext } from 'context/ListagemContext';
import { RequestListagem, RequestOptionsType, useRequestListagem } from 'hooks/useRequestListagem';
import { useGerarReembolsoContext } from 'pages/financeiro/reembolso/gerar-reembolso/contexts';

export function useQueryReembolso() {
    const { setHasPromocoes, setFgTodasPromocoes, setSelectedPromocoes } = useGerarReembolsoContext();

    const requestListagem = useRequestListagem();
    const { filter, autoLoad, sort } = useListagemContext();

    const requestOptions: RequestOptionsType = {
        url: '/financeiro/apuracaowrapper',
        sort: sort.length ? sort : [{ property: 'idPromocao', direction: 'DESC' }],
        nested: true,
        filter,
    };

    return useQuery<RequestListagem<Reembolso[]>>(['queryReembolso', requestOptions], () => requestListagem(requestOptions).then((res) => res.data), {
        enabled: autoLoad,
        onSettled: (data) => {
            setHasPromocoes((data?.data?.length || 0) > 0);

            setFgTodasPromocoes(false);

            setSelectedPromocoes({
                type: 'include',
                ids: new Set(),
            });
        },
    });
}
